module.exports = __webpack_public_path__ + "static/media/wizualizacja-69.389c3480.png";